import { ColumnsType } from 'antd/es/table';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Trans } from 'react-i18next';
import { DataView } from 'src/components/DataView/DataView';
import { Table } from 'src/components/Table/Table';
import { Sales } from 'src/generated-api-client';

type LoanApplicationMerchantSnapshotSalesTableProps = {
    sales: Sales[];
};

export const AgentLoanApplicationMerchantSnapshotSalesTable = observer(
    ({ sales }: LoanApplicationMerchantSnapshotSalesTableProps) => {
        if (!sales || sales.length === 0) {
            return (
                <div>
                    {t('Agent.LoanApplication.MerchantSnapshot.Sales.NoData')}
                </div>
            );
        }

        return (
            <Table
                columns={columns}
                dataSource={sales}
                rowKey={(record, index) =>
                    `${record.periodStart}-${index}` || String(index)
                }
                pagination={false}
            />
        );
    },
);

const columns: ColumnsType<Sales> = [
    {
        title: <Trans i18nKey="Agent.Merchant.Sales.PeriodStart" />,
        dataIndex: 'periodStart',
        key: 'periodStart',
        render: (value) => {
            return <DataView value={value} formatValue="date" />;
        },
    },
    {
        title: <Trans i18nKey="Agent.Merchant.Sales.PeriodEnd" />,
        dataIndex: 'periodEnd',
        key: 'periodEnd',
        render: (value) => {
            return <DataView value={value} formatValue="date" />;
        },
    },
    {
        title: <Trans i18nKey="Agent.Merchant.Sales.TotalCustomers" />,
        dataIndex: 'totalCustomers',
        key: 'totalCustomers',
        render: (value) => {
            return <DataView value={value} />;
        },
    },
    {
        title: <Trans i18nKey="Agent.Merchant.Sales.TotalOrders" />,
        dataIndex: 'totalOrders',
        key: 'totalOrders',
        render: (value) => {
            return <DataView value={value} />;
        },
    },
    {
        title: <Trans i18nKey="Agent.Merchant.Sales.TotalAmount" />,
        dataIndex: 'totalAmount',
        key: 'totalAmount',
        render: (value) => {
            return <DataView value={value} formatValue="currency-sar" />;
        },
    },
    {
        title: <Trans i18nKey="Agent.Merchant.Sales.AOV" />,
        dataIndex: 'aov',
        key: 'aov',
        render: (value) => {
            return <DataView value={value} formatValue="currency-sar" />;
        },
    },
    {
        title: <Trans i18nKey="Agent.Merchant.Sales.OneTimeSharePct" />,
        dataIndex: 'oneTimeSharePct',
        key: 'oneTimeSharePct',
        render: (value) => {
            return <DataView value={value} formatValue="percent" />;
        },
    },
    {
        title: <Trans i18nKey="Agent.Merchant.Sales.RepeatSharePct" />,
        dataIndex: 'repeatSharePct',
        key: 'repeatSharePct',
        render: (value) => {
            return <DataView value={value} formatValue="percent" />;
        },
    },
];
